module.exports = __webpack_public_path__ + "img/box_pro_two_1.13c6b977.jpg";